export default function deleteNil<T>(object: Record<string, T | undefined>): Record<string, T> {
  return Object.entries(object).reduce((result: Record<string, T>, [key, value]) => {
    if (value != null) {
      result[key] = value;
    }
    return result;
  }, {});
}
